import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted } from "vue";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'TripCustomerFeedback2Field',
  props: {
    mainLabel: null,
    includeFeedbackText: { type: Boolean, default: true },
    improvementOptions: null,
    name: null,
    rating: { default: 0 },
    selectedImprovements: null,
    comment: null
  },
  emits: ["update"],
  setup(__props: any, { emit }) {

const props = __props as { mainLabel: string, includeFeedbackText: boolean, improvementOptions?: Array<{
      value: string;
      text: string;
    }>, name: string, rating: number, selectedImprovements?: Array<string>, comment?: string };

const currentSelectedImprovements = ref<Array<string>>([]);
const currentComment = ref<string>("");
const currentRating = ref<number>(0);



watch(
  () => props.rating,
  (newValue) => {
    currentRating.value = newValue;
  },
  { immediate: true }
);

watch(
  () => props.selectedImprovements,
  (newValue) => {
    currentSelectedImprovements.value = newValue;
  },
  { immediate: true }
);

watch(
  () => props.comment,
  (newValue) => {
    currentComment.value = newValue;
  },
  { immediate: true }
);



const emitUpdate = () => {
  emit("update", {
    rating: currentRating.value,
    checkboxes: currentSelectedImprovements.value,
    feedback: currentComment.value,
  });
};

const handleSelectionChange = (value: string) => {
  if (currentSelectedImprovements.value.includes(value)) {
    currentSelectedImprovements.value = currentSelectedImprovements.value.filter(
      (item) => item !== value
    );
  } else {
    currentSelectedImprovements.value.push(value);
  }

  emitUpdate();
};

const handleCommentChange = (event: Event) => {
  const target = event.target as HTMLTextAreaElement;
  currentComment.value = target.value;
  emitUpdate();
};

const handleStarClick = (event: Event) => {
  const target = event.currentTarget as HTMLSelectElement;
  const starIndex = Number(target.getAttribute("data-index"));
  currentRating.value = starIndex;
  emitUpdate();
};

const ratingText = computed((): string => {
  if (currentRating.value < 1) {
    return "";
  }
  return i18n.t(`reviewsV2.RATING_${currentRating.value}`).toString();
});

return { __sfc: true,currentSelectedImprovements, currentComment, currentRating, props, emit, emitUpdate, handleSelectionChange, handleCommentChange, handleStarClick, ratingText }
}

})